<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="settings"
                :items-per-page="10"
                :loading="loading"
                class="elevation-1"            
        >
            <template v-slot:item.value="{ item }">
                <div v-if="item.type == 'html' || item.type == 'text'" class="mcb-setting-value">
                    {{ item.value }}
                </div>
                <div v-else-if="item.type == 'dateInterval'">
                    {{ item.value[0] }} - {{ item.value[1] }}
                </div>
                <div v-else-if="item.type == 'image'">
                    <v-img
                        height="50"
                        contain
                        :src="item.value"
                    ></v-img>
                </div>
                <div v-else-if="item.type == 'boolean'" class="d-flex justify-center">
                    <v-icon class="px-2 green lighten-1 elevation-2" v-if="item.value"
                        small
                        color="white darken-2"
                    >
                        mdi-check
                    </v-icon>
                    <v-icon class="px-2 red darken-4 elevation-2" v-else
                        small
                        color="white darken-2"
                    >
                        mdi-close
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="edit(item)"
                >
                    mdi-pencil
                </v-icon>
            </template>
        </v-data-table>
        <v-dialog max-width="50%" v-model="dialog" @click:outside="close">
            <v-card style="overflow: hidden;">
                <!-- Need translation -->
                <v-card-title> Edit content </v-card-title>
                <v-card-text v-if="edittingItem.type">
                    <div v-if="edittingItem.type == 'dateInterval'" class="d-flex justify-center">
                        <v-date-picker 
                            v-model="edittingItem.value"
                            range
                        ></v-date-picker>
                    </div>
                    <div v-if="edittingItem.type == 'text'">
                        <v-text-field
                            :label="edittingItem.name"
                            v-model="edittingItem.value"
                            single-line
                        ></v-text-field>
                    </div>
                    <div v-if="edittingItem.type == 'html'">
                        <tiptap-vuetify v-model="edittingItem.value" :extensions="extensions"></tiptap-vuetify>
                    </div>
                    <div v-else-if="edittingItem.type == 'image'">
                        <div>
                            <v-file-input
                                v-model="edittingItem.file"
                                accept="image/*"
                            ></v-file-input>

                            <div>
                                <v-img :src="imageURL" contain height="350"></v-img>                                
                            </div>
                        </div>
                    </div>
                    <div v-else-if="edittingItem.type == 'boolean'">
                        <!-- {{edittingItem.value}} -->
                        
                        <v-switch class="mcb-switch"
                            v-model="edittingItem.value"
                            large
                            hide-details
                        >
                            <template v-slot:label>
                                <div class="headline mr-3"> {{edittingItem.name}} </div>
                                <v-icon class="px-2 green lighten-1 elevation-2" v-if="edittingItem.value"
                                    color="white darken-2"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon class="px-2 red darken-4 elevation-2" v-else
                                    color="white darken-2"
                                >
                                    mdi-close
                                </v-icon>
                            </template>
                        </v-switch>
                    </div>
                </v-card-text>
                
                <v-card-actions>
                    
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="save"
                        alig
                    >
                        Save
                    </v-btn>
                    <v-btn
                        color="red"
                        text
                        @click="close"
                        alig
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { TiptapVuetify, Heading, Bold, 
        Italic, Strike, Underline, Code, 
        Paragraph, BulletList, OrderedList, 
        ListItem, Link, Blockquote, HardBreak, 
        HorizontalRule, History } 
from 'tiptap-vuetify'

export default {

    components: {
        TiptapVuetify,
    },
    
    data() {
        return {
            dialog: false,

            edittingItem: {
                value: null,
                type: null,
                file: null,
            },

            defaultItem: {
                value: null,
                type: null,
                file: null,
            },

            
            extensions: [
                History,
                Blockquote,
                Link,
                Underline,
                Strike,
                Italic,
                ListItem,
                BulletList,
                OrderedList,
                [Heading, {
                    options: {
                    levels: [1, 2, 3]
                    }
                }],
                Bold,
                Code,
                HorizontalRule,
                Paragraph,
                HardBreak
            ],
        }
    },

    computed: {
        ...mapGetters({
            settings: 'setting/settings',
            headers: 'setting/headers',
            loading: 'setting/loading',
        }),

        imageURL() {
            if (this.edittingItem.file) {
                return URL.createObjectURL(this.edittingItem.file)
            }
        }
    },

    methods: {
        ...mapActions({
            fetch: 'setting/fetch',
            update: 'setting/update',
        }),

        edit(item) {
            this.dialog = true;
            Object.assign(this.edittingItem, item);
        },

        close() {
            Object.assign(this.edittingItem, this.defaultItem);
            this.dialog = false;
        },

        async save() {
            let formData = new FormData();
            formData.append("id", this.edittingItem.id);
            formData.append("name", this.edittingItem.name);
            formData.append("value", this.edittingItem.value);
            formData.append("type", this.edittingItem.type);
            if (this.edittingItem.type == 'dateInterval') {
                if (!this.edittingItem.value[1]) {
                    this.edittingItem.value = [this.edittingItem.value[0], this.edittingItem.value[0]];
                } else if (this.edittingItem.value[0] > this.edittingItem.value[1]) {
                    this.edittingItem.value = [this.edittingItem.value[1], this.edittingItem.value[0]];
                } else {
                    this.edittingItem.value = [this.edittingItem.value[0], this.edittingItem.value[1]];
                }
                formData.append("value", JSON.stringify(this.edittingItem.value));
            }
            if (this.edittingItem.type == 'image') {
                formData.append("file", this.edittingItem.file);
            }
            if (this.edittingItem.type == 'boolean') {
                formData.append("value", this.edittingItem.value ? 1 : 0);
            }
            await this.update(formData);
            this.close();
        }
    },

    mounted() {
        this.fetch();
    },

}
</script>

<style>
    .mcb-setting-value {
        max-width: 60vw;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .mcb-switch label{
        margin-bottom: 0px;
    }
</style>